import { AppTheme } from "@hulanbv/ssllow-packages";
import { dictionary } from "./i18n/dictionary";

export const themeLabels: { [key in AppTheme]: string } = {
  [AppTheme.AEDES]: "Aedes",
  [AppTheme.DEFAULT]: dictionary.default,
};
